// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, *::before, *::after {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

:root {
  --bg: #0f0f0f;
  --bg-card: #161616;
  --bg-card-hover: #1c1c1c;
  --bg-input: #1a1a1a;
  --border: #2a2a2a;
  --border-strong: #333333;
  --text-primary: #f0f0f0;
  --text-secondary: #b0b0b0;
  --text-muted: #787878;
  --accent: #d4a843;
  --accent-dim: rgba(212, 168, 67, 0.12);
  --accent-border: rgba(212, 168, 67, 0.3);
  --success: #4a9e6e;
  --success-dim: rgba(74, 158, 110, 0.12);
  --danger: #c0392b;
  --radius-sm: 6px;
  --radius: 10px;
  --radius-lg: 14px;
  --mono: 'IBM Plex Mono', monospace;
  --sans: 'Inter', sans-serif;
}

html, body {
  height: 100%;
  background: var(--bg);
  color: var(--text-primary);
  font-family: var(--sans);
  font-size: 14px;
  line-height: 1.5;
  -webkit-font-smoothing: antialiased;
}

#root {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}
::-webkit-scrollbar-track {
  background: transparent;
}
::-webkit-scrollbar-thumb {
  background: var(--border-strong);
  border-radius: 3px;
}
::-webkit-scrollbar-thumb:hover {
  background: #444;
}

input[type="file"] {
  display: none;
}

button {
  font-family: var(--sans);
  cursor: pointer;
}

select {
  font-family: var(--sans);
}

/* Remove number input spinners */
input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button { -webkit-appearance: none; margin: 0; }
input[type=number] { -moz-appearance: textfield; }
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,wBAAwB;EACxB,mBAAmB;EACnB,iBAAiB;EACjB,wBAAwB;EACxB,uBAAuB;EACvB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,sCAAsC;EACtC,wCAAwC;EACxC,kBAAkB;EAClB,uCAAuC;EACvC,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,0BAA0B;EAC1B,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,WAAW;AACb;AACA;EACE,uBAAuB;AACzB;AACA;EACE,gCAAgC;EAChC,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,iCAAiC;AACjC;gDACgD,wBAAwB,EAAE,SAAS,EAAE;AACrF,qBAAqB,0BAA0B,EAAE","sourcesContent":["*, *::before, *::after {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n}\n\n:root {\n  --bg: #0f0f0f;\n  --bg-card: #161616;\n  --bg-card-hover: #1c1c1c;\n  --bg-input: #1a1a1a;\n  --border: #2a2a2a;\n  --border-strong: #333333;\n  --text-primary: #f0f0f0;\n  --text-secondary: #b0b0b0;\n  --text-muted: #787878;\n  --accent: #d4a843;\n  --accent-dim: rgba(212, 168, 67, 0.12);\n  --accent-border: rgba(212, 168, 67, 0.3);\n  --success: #4a9e6e;\n  --success-dim: rgba(74, 158, 110, 0.12);\n  --danger: #c0392b;\n  --radius-sm: 6px;\n  --radius: 10px;\n  --radius-lg: 14px;\n  --mono: 'IBM Plex Mono', monospace;\n  --sans: 'Inter', sans-serif;\n}\n\nhtml, body {\n  height: 100%;\n  background: var(--bg);\n  color: var(--text-primary);\n  font-family: var(--sans);\n  font-size: 14px;\n  line-height: 1.5;\n  -webkit-font-smoothing: antialiased;\n}\n\n#root {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n}\n\n::-webkit-scrollbar {\n  width: 6px;\n  height: 6px;\n}\n::-webkit-scrollbar-track {\n  background: transparent;\n}\n::-webkit-scrollbar-thumb {\n  background: var(--border-strong);\n  border-radius: 3px;\n}\n::-webkit-scrollbar-thumb:hover {\n  background: #444;\n}\n\ninput[type=\"file\"] {\n  display: none;\n}\n\nbutton {\n  font-family: var(--sans);\n  cursor: pointer;\n}\n\nselect {\n  font-family: var(--sans);\n}\n\n/* Remove number input spinners */\ninput[type=number]::-webkit-inner-spin-button,\ninput[type=number]::-webkit-outer-spin-button { -webkit-appearance: none; margin: 0; }\ninput[type=number] { -moz-appearance: textfield; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
